module.exports = __webpack_public_path__ + "viewer.html?13985696baabbdff68a561a3c483ae45";


//////////////////
// WEBPACK FOOTER
// ./src/assets/viewer.html
// module id = 537
// module chunks = 0